import { fetch } from '@dhl/fetch'
import { toReturnPortal, type ReturnPortalDto } from '~/model'

export const getReturnPortal = async (id: string) => {
  const returnPortalDto = await fetch<undefined, ReturnPortalDto>({
    method: 'GET',
    url: `/api/return-portals/${id}`,
  })
  return toReturnPortal(returnPortalDto)
}
